/* global Symbol */

// Note: this module depends on src/component/global/polyfill being loaded

// Third-party imports
import $ from 'jquery';
import 'parsleyjs';

// Local imports
import * as enumtool from '../util/enumtool.js';
import * as wv from '../global/worldvision.js';
import * as event from '../util/event.js';

// --------------------------------------------------------------------------
// Module vars
// --------------------------------------------------------------------------
// Module name
export const MODULE_NAME = 'donation_mod';

export let global_vars = {};

// --------------------------------------------------------------------------
// Globals
// --------------------------------------------------------------------------

// DonationKind enum
const DonationKind = {
    SINGLE: Symbol('sg_amount'),
    MONTHLY: Symbol('mp_amount'),
    YEARLY: Symbol('yr_amount'),
};

export const DonationEventKind = {
    CUSTOM_AMOUNT_ADDED: Symbol('donation.custom_amount.added'),
};

// --------------------------------------------------------------------------
//
// --------------------------------------------------------------------------

function init_shared(global) {
    let doc = global.document;
    let donate_form = doc.getElementById('donateForm');
    let form_data = donate_form.dataset;

    let donate_form_jquery = $(donate_form);

    let event_builder = new event.EventBuilder(global, DonationEventKind);

    let shared = {
        donate_form: donate_form,
        donate_form_jquery,
        product_id: form_data.productId,
        radio_inputs: donate_form.querySelectorAll(
            '.js-radio input.field-input'
        ),
        frequency_radio_inputs: donate_form.querySelectorAll(
            '.radioInput-radio'
        ),
        custom_input: donate_form.querySelector('.js-custom'),
        amount_input: donate_form.querySelector('.donationAmount'),
        sg_amount: donate_form.querySelector('#dollarAmount'),
        mp_amount: donate_form.querySelector('#dollarAmountMonthly'),
        yr_amount: donate_form.querySelector('#dollarAmountYearly'),
        sg_freqTag: donate_form.querySelector('#sgFreqTag'),
        mp_freqTag: donate_form.querySelector('#mpFreqTag'),
        yr_freqTag: donate_form.querySelector('#yrFreqTag'),
        donate_btn: donate_form.querySelector('#add'),
        give_btn: donate_form_jquery.parsley(),

        event_custom_amount_added: event_builder.create(
            DonationEventKind.CUSTOM_AMOUNT_ADDED
        ),
    };

    return shared;
}

export function initialize(global) {
    let shared = init_shared(global);
    init_radio_handler(shared);
    init_custom_input_handler(global, shared);
    init_frequency_radio_handler(shared);
    apply_query_params(global, shared);
    connus_gift(global, shared);
    connus_sympathy_option(global);
    toggle_frequency_forms(shared);
    store_checked_radio(shared);
}

function checked_radio(shared) {
    for (let input of shared.radio_inputs) {
        if (input.checked) {
            return input;
        }
    }

    return null;
}

function store_checked_radio(shared) {
    let checked_input = checked_radio(shared);
    if (checked_input === null) {
        return;
    }

    shared.amount_input.dataset.last_checked = checked_input.id;
}

function init_radio_handler(shared) {
    for (let input of shared.radio_inputs) {
        input.addEventListener('change', event => {
            let amount = event.target.value;
            clear_custom_input(shared);
            set_custom_placeholder(shared, amount);
            set_amount(shared, amount);
            store_checked_radio(shared);
        });
    }
}

function init_frequency_radio_handler(shared) {
    for (let input of shared.frequency_radio_inputs) {
        input.addEventListener('change', event => {
            clear_radio_inputs(shared);

            let selected_payment_frequency = event.currentTarget.value;
            // Default to monthly as monthly can have different frequencies (RH/MP etc)
            let [kind, show_amount] = [DonationKind.MONTHLY, show_mp_amount];
            if (selected_payment_frequency === 'SG') {
                [kind, show_amount] = [DonationKind.SINGLE, show_sg_amount];
            } else if (selected_payment_frequency === 'YR') {
                [kind, show_amount] = [DonationKind.YEARLY, show_yr_amount];
            }

            designation_code(shared, kind);
            show_amount(shared);
            set_checked(shared);
            set_type_input(shared, selected_payment_frequency);

            store_checked_radio(shared);
        });
    }
}

function init_custom_input_handler(global, shared) {
    if (!shared.custom_input) {
        return;
    }

    let handler = event => {
        let amount = event.target.value;
        // check whether input has no decimal or invalid characters
        if (amount.match(/^\d+$/g)) {
            // If the custom amount is empty, we submit the selected
            // recommended value.
            // If there is a custom amount, we don't need to set the amount
            // nor do we need to clear the radio inputs,
            // because presumably those two things occured when the
            // custom amount was input into the field
            if (event.key !== 'Enter') {
                clear_radio_inputs(shared);
                set_amount(shared, amount);
            }
        } else if (amount === '') {
            let el_id = shared.amount_input.dataset.last_checked;
            // Products like Connecting Us don't have radio buttons
            if (el_id !== undefined) {
                let el = global.document.getElementById(el_id);
                el.checked = true;
                set_amount(shared, el.value);
                shared.give_btn.reset();
            }
        }
    };
    let event_types = ['change', 'paste', 'keyup'];
    for (let e of event_types) {
        shared.custom_input.addEventListener(e, handler);
    }
}

function apply_query_params(global, shared) {
    let params = wv.get_obj(global, 'url_params');
    for (let param of Object.keys(params)) {
        if (param === 'amount') {
            add_amount(global, shared, params[param]);
        } else {
            add_hidden_input(global, params, param);
        }
    }
}

function add_amount(global, shared, amount) {
    let doc = global.document;
    let all_radio_input = doc.querySelectorAll(
        `#dollarAmount input[value="${amount}"]`
    );
    if (all_radio_input.length) {
        clear_custom_input(shared);
        for (let radio_input of all_radio_input) {
            radio_input.checked = true;
        }
    } else {
        clear_radio_inputs(shared);
        let custom_amount = doc.getElementById('customAmount');
        if (custom_amount) {
            custom_amount.value = amount;
            shared.event_custom_amount_added.trigger({
                amount: amount,
                id: 'customAmount',
            });
        }
    }
    set_amount(shared, amount);
}

function add_hidden_input(global, params, param) {
    let doc = global.document;
    let target = doc.querySelectorAll(`input[name="properties[${param}]"]`);
    if (target.length) {
        target.value = params[param];
    } else {
        let hidden = doc.querySelector('.js-hiddenFields');
        let html = hidden.innerHTML;
        html += `
            <input type="hidden"
                   name="properties[${param}]"
                   value="${params[param]}" />
        `;
        hidden.innerHTML = html;
    }
}

function set_amount(shared, amount) {
    shared.amount_input.value = amount;
}

function set_type_input(shared, frequency) {
    //shared.type_property_input.value = frequency;
    //The below code is added to set the donation type as SG (One time) or CP(Monthly), currently the above line is not setting properly
    let input_donation_type = shared.donate_form.querySelector(
        '[name="properties[type]"]'
    );
    if (input_donation_type) {
        input_donation_type.value = frequency;
    }
}

function set_checked(shared) {
    let all_amount_types = [
        shared.sg_amount,
        shared.mp_amount,
        shared.yr_amount,
    ];
    let selector = '.js-radio input.field-input';

    for (let amount_type of all_amount_types) {
        if (amount_type) {
            let all_inputs = amount_type.querySelectorAll(selector);

            if (amount_type.classList.contains('u-hide')) {
                for (let input of all_inputs) {
                    if ('checked' in input.attributes) {
                        input.removeAttribute('checked');
                    }
                    input.checked = false;
                }
            } else {
                for (let input of all_inputs) {
                    if (input.dataset.checked === 'checked') {
                        input.checked = true;
                        shared.amount_input.value = input.value;
                        clear_custom_input(shared);
                    }
                }
            }
        }
    }
}

// Called when the frequency is changed. Shows/hides the applicable
// recommended donation inputs
function toggle_frequency_forms(shared) {
    for (let input of shared.frequency_radio_inputs) {
        input.addEventListener('change', event => {
            let selectedPaymentFrequency = event.currentTarget.value;
            if (selectedPaymentFrequency === 'SG') {
                designation_code(shared, DonationKind.SINGLE);
                show_sg_amount(shared);
                show_sg_freqTag(shared);
            } else if (selectedPaymentFrequency === 'YR') {
                // We check if yearly, and not monthly, because the monthly
                // frequency can be different, but for now, yearly is always YR
                designation_code(shared, DonationKind.YEARLY);
                show_yr_amount(shared);
                show_yr_freqTag(shared);
            } else {
                designation_code(shared, DonationKind.MONTHLY);
                show_mp_amount(shared);
                show_mp_freqTag(shared);
            }
            set_checked(shared);
            store_checked_radio(shared);
            set_custom_placeholder(shared, shared.amount_input.value);
        });
    }
}

function designation_code(shared, kind) {
    let element = shared[enumtool.enum_value(kind)];
    let des_code = element.dataset.desCode;
    let hidden_input = shared.donate_form.querySelector(
        '[name="properties[des_code]"]'
    );
    hidden_input.value = des_code;
}

function show_sg_amount(shared) {
    removeHideClass(shared.sg_amount);
    addHideClass(shared.mp_amount);
    addHideClass(shared.yr_amount);
}

function show_mp_amount(shared) {
    removeHideClass(shared.mp_amount);
    addHideClass(shared.yr_amount);
    addHideClass(shared.sg_amount);
}

function show_yr_amount(shared) {
    removeHideClass(shared.yr_amount);
    addHideClass(shared.mp_amount);
    addHideClass(shared.sg_amount);
}

function show_sg_freqTag(shared) {
    removeHideClass(shared.sg_freqTag);
    addHideClass(shared.mp_freqTag);
    addHideClass(shared.yr_freqTag);
}

function show_mp_freqTag(shared) {
    removeHideClass(shared.mp_freqTag);
    addHideClass(shared.yr_freqTag);
    addHideClass(shared.sg_freqTag);
}

function show_yr_freqTag(shared) {
    removeHideClass(shared.yr_freqTag);
    addHideClass(shared.mp_freqTag);
    addHideClass(shared.sg_freqTag);
}

function addHideClass(element) {
    if (element !== null) {
        element.classList.add('u-hide');
    }
}

function removeHideClass(element) {
    if (element !== null) {
        element.classList.remove('u-hide');
    }
}

function clear_custom_input(shared) {
    let custom_input = shared.custom_input;
    if (!custom_input) {
        return;
    }
    custom_input.value = '';
    let addon = custom_input
        .closest('.field-group')
        .querySelector('.field--activeAddon');
    if (addon !== null) {
        addon.classList.remove('field--activeAddon');
    }

    let hasval = custom_input.closest('.js-hasValue');
    if (hasval !== null) {
        hasval.classList.remove('js-hasValue');
    }

    shared.give_btn.reset();
}

function set_custom_placeholder(shared, amount) {
    let custom_input = shared.custom_input;
    if (!custom_input) {
        return;
    }
    custom_input.placeholder = amount;
}

function clear_radio_inputs(shared) {
    let radio_inputs = shared.radio_inputs;
    // Products like Connecting Us don't have radio buttons
    if (radio_inputs.length === 0) {
        return;
    }

    for (let input of radio_inputs) {
        let hasval = input.closest('.js-hasValue');
        if (hasval !== null) {
            hasval.classList.remove('js-hasValue');
        }
        input.checked = false;
    }

    shared.give_btn.reset();
}

function connus_gift(global, shared) {
    let all_radio_input = shared.donate_form.querySelectorAll(
        '.radioImageInput-radio'
    );

    for (let radio_input of all_radio_input) {
        radio_input.addEventListener('change', event => {
            let cur_el = event.currentTarget;
            if (cur_el.checked === true) {
                let gift_title = cur_el
                    .closest('.radioImageInput')
                    .querySelector('.radioImageInput-label').innerHTML;
                let gift = global.document.querySelector('.connectingUsGift');
                gift.value = gift_title;
            }
        });
    }
}

function connus_sympathy_option(global) {
    let doc = global.document;
    let sympathy_el = doc.getElementById('sympathy');
    if (sympathy_el === null) {
        return;
    }

    sympathy_el.addEventListener('change', event => {
        let cur_el = event.currentTarget;
        let all_required = cur_el
            .closest('.donateForm')
            .querySelectorAll('.js-required');

        let checked = cur_el.checked ? true : false;
        doc.querySelector('.sympathySendLetter').value = checked;
        for (let el of all_required) {
            el.required = checked;
        }
    });
}
